<script>
  import { onMount } from "svelte"
  import InnerCard from "./innerCard.svelte"
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()
  import bulkJson from "../../../Stores/jsonBulkData"
  // import Pagination from "../../../Shared/pagination.svelte"
  import Pagination from "../../../../../../Shared/Table/Components/pagination.svelte"

  export let activeDoc

  /**
   * @type {string} 46 char, IPFS CID of the file
   */
  export let baseUri
  /**
   * @type {Array<import("../../../Script/document".bulkDocument)>} - it consists of filtered json list. It displayed in list.
   */
  let sortData = []
  /**
   * @type {boolean} whether to disable release button or not
   */
  let disableReleaseBtn = false
  /**
   * @type {Number} maximum page count
   */
  let maxPage
  /**
   * @type {Number} active page of the pagination
   */
  let activePage = 1

  onMount(() => {
    // Reorder the $bulkJson array to group documents based on their properties

    // Filter and concatenate documents with no fileHash that have failed
    const failedDocuments = $bulkJson.filter((a) => !a.fileHash && a.isDocumentFailed)

    // Filter and concatenate documents with no fileHash that have not failed
    const waitingDocuments = $bulkJson.filter((a) => !a.fileHash && !a.isDocumentFailed)

    // Filter and concatenate documents with a fileHash
    const completedDocuments = $bulkJson.filter((a) => a.fileHash)

    // Update the $bulkJson array to have failed, waiting, and completed documents grouped together
    $bulkJson = [...failedDocuments, ...waitingDocuments, ...completedDocuments]

    maxPage = Math.ceil($bulkJson.length / 10)

    listEntries($bulkJson)
  })

  /**
   * @description function for what are list need to show
   * @function listEntries
   */
  const listEntries = ($bulkJson) => {
    // Calculate the maximum number of pages based on the length of jsonData and the number of entries per page
    maxPage = Math.ceil($bulkJson.length / 10)

    // Create an empty array to store the sorted data
    sortData = []

    // Iterate through $bulkJson starting from the index corresponding to the current page
    for (let i = 10 * (activePage - 1); i < $bulkJson.length; i++) {
      // Check if the sortData array has reached the desired number of entries per page
      if (sortData.length < 10) {
        // Add the current $bulkJson element to the sortData array
        sortData = [...sortData, $bulkJson[i]]
      }
    }
  }
</script>

<div class="mt-3 flex w-full flex-col justify-end gap-3 mobile:flex-row">
  <button
    on:click={() => {
      dispatch("docStatus")
    }}
    type="button"
    class="disabled:text-white-200/50 flex h-9 items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-4 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed disabled:bg-blue-200/50"
  >
    <span><i class="fa-solid fa-circle-check" /></span>
    <span class="select-none">&nbsp;&nbsp;Document&nbsp;Status&nbsp;</span>
  </button>
  {#if activeDoc == "completed"}
    <button
      on:click={() => {
        dispatch("sign")
      }}
      type="button"
      class="disabled:text-white-200/50 flex h-9 items-center justify-center rounded-md border border-[#a0a1a580] bg-green-500 px-4 text-sm font-medium text-white hover:bg-green-600 hover:text-white focus:outline-none active:bg-green-500 disabled:cursor-not-allowed disabled:bg-green-200/50"
    >
      <span><i class="fa-solid fa-upload" /></span>
      <span class="select-none">&nbsp;&nbsp;Sign&nbsp;and&nbsp;Publish&nbsp;</span>
    </button>
  {/if}
</div>

<!-- <Pagination bind:sortData json={$bulkJson} /> -->
<div class="mt-3 flex w-full select-none flex-col items-center justify-between gap-3 text-sm sm:flex-row sm:gap-0 sm:text-base">
  <!-- How many entries shows in total entries -->
  <p class="font-medium text-gray-200">
    Showing {activePage * 10 - 10 + 1} to {activePage * 10 > $bulkJson.length ? $bulkJson.length : activePage * 10} of
    <span class="font-mono font-bold text-blue-500">{$bulkJson.length}</span>
    entries
  </p>

  {#if maxPage}
    <Pagination
      {maxPage}
      {activePage}
      on:pageNo={(e) => {
        activePage = e.detail
        listEntries($bulkJson)
      }}
    />
  {/if}
</div>

<div class="mt-3 flex w-full select-none flex-col gap-3">
  <!-- <div class="mb-3 flex w-full items-center justify-center gap-3 rounded-md p-2 text-sm font-bold text-white mobile:text-base">
    Click on the

    <div class="relative flex h-fit w-10 flex-shrink-0 cursor-pointer items-center justify-center rounded-md border-2 border-[#22C55E] bg-transparent text-white">
      <img src={baseUri} class="rounded-xl" alt="GeneratedFile" />
      <div class="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-[#22C55E] text-white">
        <i class="fa-solid fa-check" />
      </div>
    </div>

    below to preview the respective generated document.
  </div> -->

  {#each sortData as document (document.id)}
    <InnerCard
      documentData={document}
      {baseUri}
      on:release={() => {
        listEntries($bulkJson)
        dispatch("release")
      }}
      bind:disableReleaseBtn
    />
  {:else}
    <h1>In processing ...</h1>
  {/each}
</div>
